"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_WORLD_CURRENCY = exports.UPDATE_CHART_DATA = exports.GET_CHART_DATA = exports.UPDATE_MARKETS = exports.UPDATE_COIN_SETTING = exports.UPDATE_MYINFO = exports.UPDATE_CURRENT = exports.UPDATE_TICKER = exports.UPDATE_ALL_TICKER = exports.REMOVE_PEND_ROW = exports.UPDATE_LAST_TRADE_ROW = exports.UPDATE_LAST_TRADE = exports.UPDATE_TRADE_HISTORY = exports.UPDATE_ORDERBOOK_ROW = exports.UPDATE_ORDERBOOK_SINGLE = exports.UPDATE_ORDERBOOK = exports.UPDATE_WALLET = exports.LOGOUT = exports.LOGIN = exports.REQUEST_TRADE = exports.CHANGE_MARKET = void 0;
exports.CHANGE_MARKET = "CHANGE_MARKET";
exports.REQUEST_TRADE = "REQUEST_TRADE";
exports.LOGIN = "LOGIN";
exports.LOGOUT = "LOGOUT";
exports.UPDATE_WALLET = "UPDATE_WALLET";
exports.UPDATE_ORDERBOOK = "UPDATE_ORDERBOOK";
exports.UPDATE_ORDERBOOK_SINGLE = "UPDATE_ORDERBOOK_SINGLE";
exports.UPDATE_ORDERBOOK_ROW = "UPDATE_ORDERBOOK_ROW";
exports.UPDATE_TRADE_HISTORY = "UPDATE_TRADE_HISTORY";
exports.UPDATE_LAST_TRADE = "UPDATE_LAST_TRADE";
exports.UPDATE_LAST_TRADE_ROW = "UPDATE_LAST_TRADE_ROW";
exports.REMOVE_PEND_ROW = "REMOVE_PEND_ROW";
exports.UPDATE_ALL_TICKER = "UPDATE_ALL_TICKER";
exports.UPDATE_TICKER = "UPDATE_TICKER";
exports.UPDATE_CURRENT = "UPDATE_CURRENT";
exports.UPDATE_MYINFO = "UPDATE_MYINFO";
exports.UPDATE_COIN_SETTING = "UPDATE_COIN_SETTING";
exports.UPDATE_MARKETS = "UPDATE_MARKETS";
exports.GET_CHART_DATA = "GET_CHART_DATA";
exports.UPDATE_CHART_DATA = "UPDATE_CHART_DATA";
exports.UPDATE_WORLD_CURRENCY = "UPDATE_WORLD_CURRENCY";
